import { Head } from "@inertiajs/react"

import ContentPageLayout from "@/layouts/content-page-layout"

export default function Privacy() {
  return (
    <ContentPageLayout>
      <Head title="Privacy Policy" />

      <article className="prose-invert prose prose-lg max-w-none">
        <h1 className="font-display mb-2 text-4xl tracking-wide md:text-5xl">
          PRIVACY POLICY
        </h1>
        <p className="text-bone-muted mb-12 text-sm">
          Last updated:{" "}
          {new Date().toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </p>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">
            THE SHORT VERSION
          </h2>
          <p className="text-bone-muted">
            We don&apos;t track you. We don&apos;t sell your data. We send you
            exactly one type of email: your sign-in code. That&apos;s it.
            We&apos;re just here to help you murder your to-do list.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">
            WHAT WE COLLECT
          </h2>
          <p className="text-bone-muted mb-4">
            When you sign up, we get some basic info from your authentication
            provider (like your name and email). That&apos;s it. We store your
            tasks because, well, that&apos;s literally the point of the app.
          </p>
          <p className="text-bone-muted">
            We don&apos;t use tracking cookies. We don&apos;t run analytics. We
            don&apos;t have a marketing team salivating over your &quot;user
            journey.&quot; Your journey is your business.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">
            WHAT WE DON&apos;T DO
          </h2>
          <ul className="text-bone-muted list-inside list-disc space-y-2">
            <li>
              <strong>Sell your data.</strong> We have zero interest in this.
              Your unfinished tasks are between you and your guilt.
            </li>
            <li>
              <strong>Track you across the web.</strong> We don&apos;t know what
              other sites you visit, and frankly, we don&apos;t want to know.
            </li>
            <li>
              <strong>Spam you with emails.</strong> You get a code to sign in.
              That&apos;s the whole email strategy. Revolutionary, we know.
            </li>
            <li>
              <strong>Use your data for AI training.</strong> Your &quot;buy
              milk&quot; reminders are safe from the machine learning
              apocalypse.
            </li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">
            YOUR DEAD TASKS
          </h2>
          <p className="text-bone-muted">
            When a task dies (expires without being completed), it goes to your
            graveyard. You can view these departed tasks, mourn them briefly,
            and move on with your life. We keep them around in case you want to
            resurrect them or just need closure.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">DATA DELETION</h2>
          <p className="text-bone-muted">
            Want to delete your account and all your data? You can do that from
            your settings. When you delete your account, we delete everything.
            Your tasks, your lists, your graveyard&mdash;all of it. Gone. Like
            it never happened.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">THE PRICE</h2>
          <p className="text-bone-muted">
            ToDoOrDie is currently free. No credit card required. No
            &quot;premium tier&quot; upsells. No &quot;limited time
            offers.&quot; Just a simple app that helps you stop hoarding tasks.
            If we ever change this, we&apos;ll let you know.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">SECURITY</h2>
          <p className="text-bone-muted">
            We use industry-standard security practices. Your connection is
            encrypted. Your password is handled by our authentication provider
            (we never see it). We&apos;re not storing anything weird. Just your
            tasks, lists, and the timestamp of when each task met its maker.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-display text-2xl tracking-wide">
            CHANGES TO THIS POLICY
          </h2>
          <p className="text-bone-muted">
            If we ever update this policy, we&apos;ll post the new version here.
            Our approach is simple: collect the minimum, protect what we have,
            delete when you ask. (We take deadlines seriously. Privacy too.)
          </p>
        </section>

        <section className="border-border mt-16 border-t pt-8">
          <p className="text-bone-dim text-sm">
            Questions? Concerns? Existential dread about your data? You can
            reach us at{" "}
            <a
              href="mailto:hello@todoordie.app"
              className="text-red hover:text-red-bright transition-colors"
            >
              hello@todoordie.app
            </a>
            . We might even respond. Eventually.
          </p>
        </section>
      </article>
    </ContentPageLayout>
  )
}
